import { render } from "./QwilrInfoPage.vue?vue&type=template&id=77b8322e&ts=true"
import script from "./QwilrInfoPage.vue?vue&type=script&lang=ts"
export * from "./QwilrInfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__